import { HTTP } from '../../utils/http';
import { PaginationParams } from '../../utils/pagination-params';

export const UsersService = {

    changeLogo(schoolId, userId, file) {
        const headers = {'Content-Type': 'multipart/form-data'};
        const formData = new FormData();
        formData.append('logo', file);
        return HTTP.patch(`/schools/${schoolId}/users/${userId}/logo`, formData, { headers });
    },

    editProfileInfo(schoolId, userId, form) {
        return HTTP.patch(`/schools/${schoolId}/users/${userId}/personal-info`, form);
    },

    getProfileInfo(schoolId, userId) {
        return HTTP.get(`/schools/${schoolId}/users/${userId}/personal-info`);
    },

    changePassword(schoolId, userId, form) {
        return HTTP.patch(`/schools/${schoolId}/users/${userId}/password`, form);
    },

    requestEmailUpdate(schoolId, userId, form) {
        const headers = {'Content-Type': 'plaint/text'};
        return HTTP.patch(`/schools/${schoolId}/users/${userId}`, form.email, { headers });
    },

    getLogo(schoolId, userId) {
        const headers = {
            global: true
        };
        return HTTP.get(`/schools/${schoolId}/logo?userId=${userId}`, { headers });
    },

    removeLogo(schoolId, userId) {
        return HTTP.delete(`/schools/${schoolId}/users/${userId}/logo`);
    },

    getUsers(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`schools/${schoolId}/users`);
        return HTTP.get(url);
    },

    getInstructors(schoolId) {
        return HTTP.get(`schools/${schoolId}/users/instructors`);
    },

    addInstructor(schoolId, form) {
        return HTTP.post(`schools/${schoolId}/instructors`, form);
    },

    updateEmail(token) {
        return HTTP.patch(`/no-auth/users/email-update?emailChangeToken=${token}`);
    },

    updateUserRole(schoolId, userId, role) {
        return HTTP.patch(`/schools/${schoolId}/users/${userId}/role`, { role });
    },

    sendEmailToSchoolUsers(schoolId, body, attachment) {
        const headers = {
            'Content-type': 'multipart/form-data'
        };
        const formData = new FormData();
        const form = JSON.stringify(body);
        formData.append("emailForm", form);
        Object.values(attachment).forEach((el) => {
            formData.append(`attachment`, el);
        });
        return HTTP.post(`/schools/${schoolId}/users/users-emails`, formData, { headers });
    }
};


// WEBPACK FOOTER //
// ./src/common/services/settings/users.service.js